const MONTHS_ID = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

const formatDate = (date) => {
  const d = new Date(date);
  return `${String(d.getDate()).padStart(2, "0")} ${
    MONTHS_ID[d.getMonth()]
  } ${d.getFullYear()}`;
};

const isLastDayOfMonth = (date) => {
  const d = new Date(date);
  return (
    d.getDate() ===
    new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()
  );
};

export function formatPeriodLabel(startDate, endDate) {
  const now = new Date();

  // Default: tahun berjalan
  if (!startDate || !endDate) {
    return `Tahun ${now.getFullYear()}`;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  const sameDay =
    start.toDateString() === end.toDateString();

  const sameMonth =
    start.getMonth() === end.getMonth() &&
    start.getFullYear() === end.getFullYear();

  const fullYear =
    start.getDate() === 1 &&
    start.getMonth() === 0 &&
    end.getDate() === 31 &&
    end.getMonth() === 11 &&
    start.getFullYear() === end.getFullYear();

  const fullMonth =
    sameMonth &&
    start.getDate() === 1 &&
    isLastDayOfMonth(end);

  // Tahun penuh
  if (fullYear) {
    return `Tahun ${start.getFullYear()}`;
  }

  // Satu hari
  if (sameDay) {
    return `${MONTHS_ID[start.getMonth()]} ${start.getFullYear()}`;
  }

  // Satu bulan penuh (BENAR-BENAR full)
  if (fullMonth) {
    return `${MONTHS_ID[start.getMonth()]} ${start.getFullYear()}`;
  }

  // Selain itu → periode
  return `Periode ${formatDate(start)} s/d ${formatDate(end)}`;
}
